import React, { useEffect } from "react";
interface BaseModalProps {
  active: boolean;
  title: string;
  children: React.ReactNode;
  size?: "sm" | "md" | "lg";
  scrollable?: boolean;
}
export const BaseModal = (props: BaseModalProps) => {
  const modalRef = React.useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (!modalRef.current) {
      return;
    }
    if (props.active) {
      modalRef.current.showModal();
    } else {
      modalRef.current.close();
    }
  }, [props.active]);

  const sizes = {
    sm: "w-64",
    md: "w-[460px]",
    lg: "w-128",
  };

  return (
    <dialog ref={modalRef} className="modal">
      <div
        className={`${
          !props.active ? "pointer-events-none" : ""
        } modal-box rounded-none p-0 ${props.size && sizes[props.size]}`}
      >
        <h4
          className={`bg-blue-950 w-full py-2 px-3 text-white text-lg font-bold ${
            props.scrollable ? "sticky" : ""
          } top-0 z-50`}
        >
          {props.title}
        </h4>
        <div>{props.children}</div>
      </div>
    </dialog>
  );
};
